import { useExperimentQueryParams } from 'shared/hooks/useExperimentQueryParams';

/**
 * Component that processes experiment query parameters from the URL.
 * Must be rendered inside a Router context since it uses useLocation().
 */
export const ExperimentQueryParamsHandler = () => {
  useExperimentQueryParams();
  return null;
};

export default ExperimentQueryParamsHandler;
